import actions from './actions';

const initialState = {
  allUserExperimentVariables: {
    stripe_url: 'https://liqural-stripe-dev.azurewebsites.net/api/StripeSubscriptionCheckout?',
    oil_product_plan: 'default_plan',
  },
};

const {
  GET_USERS_EXPERIMENT_SUCCESS,
  GET_USERS_EXPERIMENT_ERR,
  SET_USERS_EXPERIMENT_SUCCESS,
  SET_USERS_EXPERIMENT_ERR,
} = actions;

const userExperimentsDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_USERS_EXPERIMENT_SUCCESS:
      return state;
    case GET_USERS_EXPERIMENT_ERR:
      return err;
    case SET_USERS_EXPERIMENT_SUCCESS:
      return {
        ...state,
        allUserExperimentVariables: data,
      };
    case SET_USERS_EXPERIMENT_ERR:
      return err;
    default:
      return state;
  }
};

export { userExperimentsDataReducer };
